<template>
  <div class="classfiy-list-box">
    
    <div class="list-box">
      <span v-for="item, index in list" :key="index" @click="toGoodsList(item.catName1)">{{ item.catName1 }}</span>
    </div>

  </div>
</template>
<script>
export default {
  name: 'ClassifyList',
  components: {
  },
  props: {},
  data() {
    return {
      list: [],
    }
  },
  watch: {},
  computed: {},
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$ajax('/iap-api/wan4/presonal/cart/myCartCount.do', {}).then(res => {
        this.list = res.data.wan4Catalog;
      })
    },
    toGoodsList(catName){
      this.$router.push(`/goods/list?catName=${catName}&type=1`)
    }
  },
}
</script>
<style lang="less" scoped>
.classfiy-list-box {
  display: flex;
  flex-direction: column;
  background: #fff;
  min-height: 100vh;
  padding-bottom: 100px;

  .list-box {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 18px 16px;
    width: 100vw;
    padding: 32px 24px 120px 24px;
    border-top: 8px solid #F8F8F8;

    >span {
      height: 134px;
      border-radius: 4px;
      background: url('https://xhdata.wan4.com/wsw-h5-15.png') no-repeat center;
      background-size: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #FFF;
      font-size: 32px;
      font-style: normal;
      font-weight: bold;
    }
  }




}
</style>